import { Component, OnChanges } from '@angular/core';
import { AbstractControl, FormGroupDirective, FormControl, FormArray } from '@angular/forms';

import { ErrorStateMatcher } from '@angular/material/core';
import { MatFormField } from '@angular/material/form-field';

import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

import { ContactGroup } from '@library/common/models';
import { AppConfigService } from '@library/app.config';

export class NameErrorStateMatcher implements ErrorStateMatcher {
   isErrorState( control: FormControl | null, form: FormGroupDirective | null ): boolean {
      return !!(( control && control.invalid ) || ( form && form.touched && form.invalid && form.hasError( 'nameRequired' )));
   }
}
export class OneOfErrorStateMatcher implements ErrorStateMatcher {
   isErrorState( control: FormControl | null, form: FormGroupDirective | null ): boolean {
      return !!(( control && control.invalid ) || ( form && form.touched && form.invalid && form.hasError( 'oneRequired' )));
   }
}

@UntilDestroy()
@Component({
   selector: 'lib-contacts',
   templateUrl: './contacts.component.html',
   styleUrls: ['./contacts.component.scss'],
   inputs: [ 'contacts' ],
})
export class ContactsComponent implements OnChanges {

   contacts: FormArray;

   lengths;
   required;

   nameMatcher = new NameErrorStateMatcher();
   oneOfMatcher = new OneOfErrorStateMatcher();

   constructor( private config: AppConfigService ) {
      const loadedConfig = this.config.getExtendedConfig( 'contact' );
      this.lengths = this.config.getProperty( loadedConfig, 'maxLength' );
      this.required = this.config.getProperty( loadedConfig, 'required' );
   }

   ngOnChanges(): void {
      // sorting contacts
      this.sort();

      // adding "magic" contact
      this.addContact();

      // listening for "magic" contact change
      this.contacts.valueChanges.pipe(
         untilDestroyed( this ),
      ).subscribe( contacts => {
         const last = contacts.slice( -1 )[0];
         if ( !last || last.name ) { this.addContact(); }
      });
   }

   addContact(): void {
      this.contacts.push( ContactGroup() );
   }

   focused( field: MatFormField ): boolean {
      return field && field._control.focused;
   }

   pin( contact: AbstractControl, value: 'pin' | 'primary' | null ) {
      contact.get('pinned').setValue( false );
      contact.get('default').setValue( false );

      switch ( value ) {
         case 'primary':
            this.contacts.controls.map( c => c.get( 'default' ).setValue( false ));
            contact.get('default').setValue( true );
            contact.get('pinned').setValue( true );
         case 'pin':
            contact.get('pinned').setValue( true );
      }

      this.sort();
   }

   sort() {
      this.contacts.setValue(
         this.contacts.value
            .sort(( a, b ) => {
               const checka = a.name.toLowerCase();
               const checkb = b.name.toLowerCase();

               if ( !checka || !checkb ) { return 0; }

               // sort by default
               if ( a.default !== b.default ) { return ( a.default ) ? -1 : 1; }

               // sort by pinned
               if ( a.pinned !== b.pinned ) { return ( a.pinned ) ? -1 : 1; }

               // sort alphabetically
               return ( checka > checkb ) ? 1 : ( checkb > checka ) ? -1 : 0;
            })
      );
   }
}
